export default __webpack_public_path__ + "img/input-error.6c320f8f57c80446fa2eee0e11c691bd.svg";